import {createContext} from 'react';

const CommandPaletteContext = createContext({
  open: false,
  setOpen: () => {}
});

export default CommandPaletteContext;
